import React from 'react';
import { useSpotify } from '../../contexts/SpotifyContext';
import SpotifyIcon from './SpotifyIcon';

/**
 * Compact "Listening to Spotify" badge for team / chat views.
 */
const NowPlaying = ({ userId, activity: activityProp, className = '' }) => {
  const { peerActivity } = useSpotify();
  const activity = activityProp || (userId ? peerActivity?.[userId] : null);

  if (!activity?.is_playing || !activity?.track_name) return null;

  return (
    <div
      className={`inline-flex items-center gap-1.5 max-w-full text-[11px] text-[#1DB954] ${className}`}
      data-testid="spotify-now-playing"
      title={`Listening to ${activity.track_name}${activity.artist ? ` — ${activity.artist}` : ''}`}
    >
      <SpotifyIcon className="h-3.5 w-3.5 flex-shrink-0 text-[#1DB954]" />
      <span className="truncate">
        Listening to <span className="font-medium">{activity.track_name}</span>
        {activity.artist ? (
          <span className="text-secondary-500 dark:text-secondary-400"> · {activity.artist}</span>
        ) : null}
      </span>
    </div>
  );
};

export default NowPlaying;
